// @flow

import _ from 'lodash';

export const getToken = () => _.get(JSON.parse(localStorage.getItem('reduxState') || '{}'), ['Login', 'authenticationData', 'jwt']) || null;
export const getUsername = () => _.get(JSON.parse(localStorage.getItem('reduxState') || '{}'), ['Profile', 'profileData', 'profile_info', 'username']) || null;
export const getUserId = () => _.get(JSON.parse(localStorage.getItem('reduxState') || '{}'), ['Profile', 'profileData', 'profile_info', 'id']) || null;
